import React from 'react'
import { connect } from 'react-redux'
import { Redirect } from 'react-router-dom'
import AuthHeader from './AuthHeader'
import { MuiThemeProvider, createMuiTheme } from '@material-ui/core/styles';
import BlueTypography from './typography/BlueTypography';
import Paper from '@material-ui/core/Paper';
import Grid from '@material-ui/core/Grid';

import {
  confirm_token
} from '../actions'

const font = "'Noto Sans', sans-serif";

const theme  = createMuiTheme({
    typography: {
    fontFamily: font
  }
});

const mapStateToProps = state => {
  return {
    confirmed: state.auth.confirmed,
    isConfirming: state.auth.isConfirming,
    errors: state.auth.errors
  }
}

const mapDispatchToProps = dispatch => {
  return {
    confirm: token => dispatch( confirm_token(token) )
  }
}

class ConnectedUserConfirm extends React.Component {
  state = {
    error: false,
    success: false
  }

  componentWillMount() {
    const {token} = this.props.match.params
    this.props.confirm(token)
  }

  componentDidUpdate(prevProps, prevState) {
    const {confirmed, isConfirming} = this.props
    if (confirmed && !prevProps.confirmed) {
      window.showSnackbar('success', 'Your account has been activated. Please, log in.')
      this.setState({success: true})
    } else if (!confirmed && !isConfirming && !prevProps.confirmed && prevProps.isConfirming) {
      // window.showSnackbar('error', 'Error in account validation.')
      this.setState({error: true})
    }
  }

  render() {
    const {success, error} = this.state
    const {errors} = this.props

    if (success) {
      return <Redirect to="/" />
    }

    if (error) {
      return (
        <MuiThemeProvider theme={theme}>
          <section className="header">

            <AuthHeader />

            <div className="inner">
              <Grid container spacing={0} justify="center">
                <Grid item xs={12} md={4}>
                  <Paper className="no-boxshadow">
                    <div>
                      <BlueTypography
                        variant="display1"
                        align="center"
                        className="c-blue ls-025"
                      >
                        Account Confirmation Failed
                      </BlueTypography>

                      <div className="mt-24">
                        <BlueTypography
                          className="ls-28 ls-050"
                          variant="subheading"
                          align="center"
                        >
                          {
                            errors.length > 0 && errors.join(<br />)
                          }
                        </BlueTypography>
                      </div>


                    </div>
                  </Paper>
                </Grid>
              </Grid>
            </div>

          </section>
        </MuiThemeProvider>
      )
    }

    return ''
  }
}

const UserConfirm = connect(mapStateToProps, mapDispatchToProps)(ConnectedUserConfirm)
export default UserConfirm



// WEBPACK FOOTER //
// ./src/js/components/UserConfirm.js